module.exports = __webpack_public_path__ + "static/artist-development-results-1566f7b5cc26e60075decba5ea17549c.webp";